import router from '@/router';
import { openedTabListSet as _setOpenedTabs } from '@/service/userdata-service';
import {
    addOpenedTab,
    createNewTab,
    getFocusedRouteName,
    getFocusedTab,
    getFocusedViewId,
    getHomeView,
    getOpenedTabs,
    setFocusedTab,
    setOpenedTabs,
} from '@/layouts/main-layout/components/navigation-bars-data';

export default {
    state() {
        return {
            userData: {
                changes: [],
                data: {},
            },
            focusedInstanceId: null,
            saveUserData: null,
            prepareChanges: null,
        };
    },
    mutations: {
        setData(state, { data }) {
            state.userData.data = data;
        },
        setSaveUserData(state, saveUserData) {
            state.saveUserData = saveUserData;
        },
        setPrepareChanges(state, { callback }) {
            state.prepareChanges = callback;
        },
        addChange(state, { change }) {
            state.userData.changes.push(change);
        },
        updateChange(state, { change }) {
            const index = state.userData.changes.findIndex(item => item.field === change.field);
            state.userData.changes[index].value = change.value;
        },
        updateFocusedOpenedTab(state, { pendingTab }) {
            const index = getOpenedTabs().findIndex(
                tab => tab.viewId === getFocusedViewId() && tab.instanceId === state.focusedInstanceId
            );
            getOpenedTabs()[index] = pendingTab;
        },
    },
    actions: {
        // tabs
        saveUserData({ commit }, { changes }) {
            commit('setSaveUserData', { changes });
        },
        addTabs({ dispatch }, { tabs }) {
            console.log(dispatch);
            if (!getOpenedTabs()?.length) {
                setOpenedTabs([
                    {
                        src: '/infoenergo/assets/home.svg',
                        name: 'home-view',
                        buttonCloseHide: true,
                    },
                ]);
            }
            for (const tab of tabs) {
                const match = getOpenedTabs().some(
                    openedTab => openedTab.viewId === tab.viewId && openedTab.instanceId === tab.instanceId
                );

                if (!match) {
                    addOpenedTab(tab);
                    setFocusedTab(tab);
                }
            }
        },

        checkAndUpdateFocusedOpenedTab({ state, commit }) {
            const currentTab = getOpenedTabs().find(tab => {
                return tab.viewId === getFocusedViewId() && tab.instanceId === state.focusedInstanceId;
            });
            if (currentTab) {
                const view = router.getRoutes().find(view => view.name === currentTab.name);
                const newTitle = computeTitle(state, view);
                if (currentTab.title !== newTitle) {
                    const pendingTab = {
                        viewId: getFocusedViewId(),
                        instanceId: state.focusedInstanceId,
                        name: getFocusedRouteName(),
                        title: newTitle,
                    };
                    commit('updateFocusedOpenedTab', { pendingTab });
                }
            }
        },

        async sendUpdatedOpenedTabs() {
            const args = {
                tabs: getOpenedTabs().filter(tab => {
                    return tab.name !== 'home-view';
                }),
                focused: getFocusedTab(),
            };
            await _setOpenedTabs(args);
        },
        addChanges({ commit, state }, { changes }) {
            for (const change of changes) {
                const match = state.userData.changes.find(item => item.field === change.field);
                if (match) {
                    commit('updateChange', { change });
                } else commit('addChange', { change });
            }
        },

        // чистые данные, нужны для корректной валидации changes
        setUserDataRawData({ commit, dispatch }, data) {
            commit('setData', { data });
            dispatch('checkAndUpdateFocusedOpenedTab');
            return true;
        },

        // обработка роутинга при переходе на другой таб (смена фокуса таба)
        async internalRoute({ dispatch, state }, { routeName, id }) {
            // TODO: не работает фокусировка рефреше
            // TODO: надо бы добавить выделение жирным на объекты где есть uaserData.changes
            const routePath = router.currentRoute.value?.path;
            if (routeName === 'home-view') {
                setFocusedTab(getHomeView());
                await dispatch('sendUpdatedOpenedTabs');
            } else {
                const currentTab = getCurrentTab(state, { routeName, instanceId: id || null });
                // смена текущего таба на другой из уже существующих
                if (currentTab) {
                    setFocusedTab(currentTab);
                    await dispatch('sendUpdatedOpenedTabs');
                }
                // добавление нового таба в таб-бар
                else {
                    createNewTab({ dispatch, state }, { routeName, instanceId: id || null, routePath });
                }
            }
        },
    },
    getters: {
        hasUniqueChanges: state => view => {
            if (view) {
                if (view.viewId !== getFocusedViewId() || view.instanceId !== state.focusedInstanceId) return false;
            }

            const uniqueChanges = state.userData.changes.filter(
                change => change.value !== state.userData.data[change.field]
            );
            return !!uniqueChanges.length;
        },
    },
};

// const createNewTab = ({ state }, { routeName, instanceId, routePath }) => {
//     let _route = router
//         .getRoutes()
//         .find(rout => rout.name === routeName && rout.meta !== undefined && rout.meta?.layout?.name === 'main-layout');

//     // если view не используется в main-layout
//     if (!_route) {
//         return { result: false, uuid: '167ec275-bc72-4167-a5f6-7cfc2e13414a', msg: 'cant find view in default views' };
//     }

//     const viewId = _route.meta.viewId;
//     const title = computeTitle(state, _route);

//     const tab = { viewId, instanceId, title, routeName, routePath };
//     addOpenedTab(tab);
//     setFocusedTab(tab);
//     const view = getOpenedTabs().find(tab => tab.routePath === routePath);
//     setFocusedTab(view);
// };
const computeTitle = (state, currentRoute) => {
    if (currentRoute) {
        if (currentRoute.name === 'home-view') return '';

        const title = currentRoute.meta.title;
        // TODO: понять как подставлять значение из базы вместо ... потому что всегда ожидаем await
        // if (titleKey) {
        //     const titlePostfix = titleKey
        //         .split(',')
        //         .map(title => state.userData.data[title])
        //         .join(' ');
        // return titlePostfix ? `${title}: ${titlePostfix}` : `${title}: ...`;
        return title;
    }
    return 'NOT DEFINED TAB VIEW';
};

const getCurrentTab = (state, { routeName, instanceId }) => {
    const tabs = getOpenedTabs()?.filter(tab => tab.routeName === routeName);
    if (tabs.length > 0) {
        if (instanceId) {
            const tab = tabs.find(tab => tab.instanceId === instanceId);
            return tab ? tab : null;
        } else return tabs[0];
    }
    return null;
};
